import { createTypesenseInstantSearchClient } from '~/lib/search/typesenseInstantSearch'
import type { TypesenseSearchConfig } from '~/lib/search/typesense'

/**
 * Search client for AisInstantSearch, shared per process. Only the listing pages (category, search) use it,
 * so the InstantSearch adapter is not part of every page (useTypesenseSearch.ts is the general search).
 */

let _typesenseInstantSearchClient: ReturnType<typeof createTypesenseInstantSearchClient> | null = null

export function useSearchClient() {
  if (!_typesenseInstantSearchClient) {
    _typesenseInstantSearchClient = createTypesenseInstantSearchClient(useRuntimeConfig().public.search.typesense as unknown as TypesenseSearchConfig)
  }
  return _typesenseInstantSearchClient
}
